// Design System 2.0 (2026-10, Phase 1 FIX PASS) — the ONE tone map for status colour.
// Every key that existed before Phase 1 keeps its PRE-Phase-1 meaning, remapped onto the
// nearest of the 5 new tones (see the table in the Phase 1 fix report). Keys that only ever
// existed in the Design System brief's own Status->tone table (draft, cancelled, invited,
// open, candidate, etc.) keep the brief's meaning. Unknown values stay grey/neutral with the
// raw label. Never used for production stage or health — those are StageGlyph/StageStepper
// and HealthMarker respectively.
export const TONE_CHIP_CLS = {
  grey: "bg-tone-grey-bg text-tone-grey-text",
  blue: "bg-tone-blue-bg text-tone-blue-text",
  green: "bg-tone-green-bg text-tone-green-text",
  gold: "bg-tone-gold-bg text-tone-gold-text",
  red: "bg-tone-red-bg text-tone-red-text",
};
export const TONE_DOT_CLS = {
  grey: "bg-tone-grey-dot",
  blue: "bg-tone-blue-dot",
  green: "bg-tone-green-dot",
  gold: "bg-tone-gold-dot",
  red: "bg-tone-red-dot",
};

const STATUS_TONE = {
  // --- Restored to their PRE-Phase-1 meaning (see fix-pass report for the old->new table) ---
  new: "blue", lead: "blue", proposed: "blue", sent: "blue",
  accepted: "blue", activated: "blue",
  active: "green", won: "green", delivered: "green", approved: "green", paid: "green",
  "pre-production": "gold", production: "gold", post: "gold", pending: "gold",
  "pending review": "gold", "clarification requested": "gold", "sent to freelancer": "gold",
  "at risk": "red", lost: "red", declined: "red",
  archived: "grey",
  // --- Brief-only keys (never existed before Phase 1 — brief meaning, unchanged) ---
  "post-production": "gold",
  draft: "grey",
  "draft assignment": "grey", completed: "grey", cancelled: "red",
  invited: "blue", revoked: "red",
  open: "blue", done: "grey",
  candidate: "gold", published: "green", rejected: "red",
  available: "green", "not specified": "grey",
  // Build Opportunities (2026-10, Phase 6) — "source_unavailable" was its own distinct orange
  // before this chip existed (AdminOpportunities.jsx's old STATUS_STYLE); gold is the closest
  // tone to orange, keeping it visually apart from the plain-grey expired/closed/archived.
  source_unavailable: "gold",
};

export function statusTone(status) {
  const key = (status || "").toString().trim().toLowerCase();
  return STATUS_TONE[key] || "grey";
}

/** Status chip — 6px dot + label, 22px tall, radius 4. For pipeline status and every other
 * record status. NEVER for production stage (StageGlyph) or health (HealthMarker). */
export function StatusChip({ status, testId }) {
  const tone = statusTone(status);
  const label = status || "No status";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 h-[22px] rounded px-2 text-[11px] font-medium leading-none ${TONE_CHIP_CLS[tone]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full shrink-0 ${TONE_DOT_CLS[tone]}`} />
      {label}
    </span>
  );
}
